import { RightIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function MobilePanelNavItem({
  children,
  itemId,
  onClickItem,
  title
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Clickable, {
      onClick: () => onClickItem(itemId),
      style: {
        width: '100%'
      },
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        blockSize: "50px",
        borderBlockEndColor: "border-core-subtle",
        borderBlockEndWidth: "100",
        borderBlockEndStyle: "solid",
        justifyContent: "space-between",
        paddingBlock: "250",
        paddingInlineEnd: "500",
        paddingInlineStart: "700",
        children: [title, /*#__PURE__*/_jsx(View, {
          children: children && /*#__PURE__*/_jsx(RightIcon, {
            color: "fill-info-default",
            size: "600"
          })
        })]
      })
    }), children]
  });
}